import { findIconDefinition, library } from '@fortawesome/fontawesome-svg-core';

import {
  faBuilding,
  faHouse,
  faUserGroup,
  faPeopleGroup,
  faBooks,
  faLanguage,
  faBell,
  faUser,
  faCircleArrowUpRight,
  faArrowLeft,
  faArrowRight,
  faPlus,
  faFileExport,
  faClipboardUser,
  faFileUser,
  faTriangleExclamation,
  faXmark,
  faXmarkLarge,
  faChevronUp,
  faChevronDown,
  faUserHelmetSafety,
  faUserTie,
  faMagnifyingGlass,
  faEye,
  faEyeSlash,
  faMinus,
  faChain,
  faChainBroken,
  faLock,
  faUnlock,
  faBars,
  faRotateLeft,
  faEdit,
  faCaretUp,
  faCaretDown,
  faStar,
  faChevronRight,
  faCopy,
  faKey,
  faFloppyDisk,
  faUserPlus,
  faTrophy,
  faTrashCan,
  faFileUpload,
  faBoltLightning,
  faBoxArchive,
  faArrowDown19,
  faCalendarLines,
  faCalendarLinesPen,
  faArrowUp,
  faArrowDown,
  faObjectGroup,
  faObjectUngroup,
  faObjectUnion,
  faObjectIntersect,
  faMerge,
  faSplit,
  faCalendarPlus,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faArrowDownLeftAndArrowUpRightToCenter,
  faThumbsUp,
  faThumbsDown,
  faCommentArrowUp,
  faCircleHalfStroke,
  faUtensils,
  faCheck,
  faCheckDouble,
  faCircle,
  faCircleCheck,
  faCircleQuestion,
  faCircleXmark,
  faEnvelope,
  faEnvelopeCircleCheck,
  faEraser,
  faQuestion,
  faList,
  faDollarSign,
  faTrashXmark,
  faTrashCheck,
  faFilter,
  faCircleDot,
  faBook,
  faSparkles,
  faTableRows,
  faTableColumns,
  faRotate,
  faFire,
  faArrowsLeftRight,
  faImage,
  faArrowUpRight,
  faInfo,
  faShirt,
  faAnchor,
  faArrowsTurnToDots,
  faMarker,
  faHighlighter,
  faFile,
  faEyeLowVision,
  faHighlighterLine,
  faBorderOuter,
  faLineHeight,
  faCogs,
  faCog,
  faPlug,
  faTv,
  faMobile,
  faLaptopMobile,
  faCalendarDays,
  faI,
  faP,
  faS,
  faSignPosts,
  faCircleDollar,
  faExclamation,
  faInfoCircle,
  faInventory,
  faPaperPlane,
  faPencil,
  faSparkle,
  faTachometerFastest,
  faTachometerSlowest,
  faTag,
  faTilde,
  faServer,
  faClone,
  faTasks,
  faPen,
  faC,
  faClock,
  faBoxOpen,
  faGripVertical,
  faPuzzlePiece,
  faTicket,
  faArrowDownTriangleSquare,
  faDiamonds4,
  faPipe,
  faRepeat,
  faCalendarDay,
  faQrcode,
  faBan,
  faReceipt,
  faArrowRightArrowLeft,
  faCircleDashed,
} from '@awesome.me/kit-ff9dd7b804/icons/modules/classic/solid';

import {
  faStar as farStar,
  faClock as farClock,
} from '@awesome.me/kit-ff9dd7b804/icons/modules/classic/regular';

import {
  faChartTreeMap,
  faMemoPad,
  faNewspaper,
} from '@awesome.me/kit-ff9dd7b804/icons/modules/sharp/solid';

import {
  faSolidMobileSlash,
  faSolidPlugSlash,
  faSolidTvSlash,
  faSolidBoxArchiveCircleCheck,
  faSolidBoxArchiveCircleXmark,
  faSolidDollarSignSlash,
  faSolidLanguageSlash,
  faSolidMobileScreenButtonSlash,
  faSolidSignPostsSlash,
  faSolidLaptopMobileSlash,
  faSolidCalendarDaysSlash,
  faSharpSolidNewspaperSlash,
  faSolidTagSlash,
  faSolidBoxOpenPen,
  faSolidTicketPen,
  faSolidPuzzlePiecePen,
} from '@awesome.me/kit-ff9dd7b804/icons/modules/kit/custom';

library.add(
  faBuilding,
  faHouse,
  faUserGroup,
  faPeopleGroup,
  faBooks,
  faLanguage,
  faBell,
  faUser,
  faCircleArrowUpRight,
  faMemoPad,
  faArrowLeft,
  faArrowRight,
  faArrowUpRight,
  faPlus,
  faFileExport,
  faClipboardUser,
  faFileUser,
  faTriangleExclamation,
  faXmark,
  faXmarkLarge,
  faChevronUp,
  faChevronDown,
  faChartTreeMap,
  faUserHelmetSafety,
  faUserTie,
  faMagnifyingGlass,
  faEye,
  faEyeSlash,
  faMinus,
  faChain,
  faChainBroken,
  faLock,
  faUnlock,
  faBars,
  faRotateLeft,
  faEdit,
  faCaretUp,
  faCaretDown,
  faStar,
  farStar,
  faChevronRight,
  faKey,
  faCopy,
  faFloppyDisk,
  faUserPlus,
  faTrophy,
  faTrashCan,
  faFileUpload,
  faBoltLightning,
  faBoxArchive,
  faArrowDown19,
  faCalendarLines,
  faCalendarLinesPen,
  faArrowUp,
  faArrowDown,
  faObjectGroup,
  faObjectUngroup,
  faObjectUnion,
  faObjectIntersect,
  faMerge,
  faSplit,
  faCalendarPlus,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faArrowDownLeftAndArrowUpRightToCenter,
  faThumbsUp,
  faThumbsDown,
  faCommentArrowUp,
  faCircleHalfStroke,
  faUtensils,
  faCheck,
  faCheckDouble,
  faCircle,
  faCircleCheck,
  faCircleQuestion,
  faCircleXmark,
  faEnvelope,
  faEnvelopeCircleCheck,
  faEraser,
  faQuestion,
  faList,
  faDollarSign,
  faTrashXmark,
  faTrashCheck,
  faFilter,
  faCircleDot,
  faBook,
  faNewspaper,
  faSparkles,
  faTableRows,
  faTableColumns,
  faRotate,
  faFire,
  faArrowsLeftRight,
  faImage,
  faInfo,
  faShirt,
  faAnchor,
  faArrowsTurnToDots,
  faMarker,
  faHighlighter,
  faFile,
  faEyeLowVision,
  faHighlighterLine,
  faBorderOuter,
  faLineHeight,
  faCog,
  faCogs,
  faPlug,
  faTv,
  faMobile,
  faSolidMobileSlash,
  faSolidPlugSlash,
  faSolidTvSlash,
  faSolidBoxArchiveCircleCheck,
  faSolidBoxArchiveCircleXmark,
  faSolidDollarSignSlash,
  faSolidLanguageSlash,
  faSolidMobileScreenButtonSlash,
  faS,
  faI,
  faP,
  faC,
  faLaptopMobile,
  faSolidLaptopMobileSlash,
  faSignPosts,
  faSolidSignPostsSlash,
  faCalendarDays,
  faSolidCalendarDaysSlash,
  faSharpSolidNewspaperSlash,
  faTag,
  faSolidTagSlash,
  faPaperPlane,
  faTilde,
  faPencil,
  faExclamation,
  faTachometerSlowest,
  faTachometerFastest,
  faInfoCircle,
  faInventory,
  faCircleDollar,
  faSparkle,
  faServer,
  faClone,
  faTasks,
  faPen,
  faSolidBoxOpenPen,
  faSolidTicketPen,
  faSolidPuzzlePiecePen,
  faClock,
  faGripVertical,
  faBoxOpen,
  faTicket,
  faPuzzlePiece,
  faArrowDownTriangleSquare,
  farClock,
  faDiamonds4,
  faPipe,
  faRepeat,
  faCalendarDay,
  faQrcode,
  faBan,
  faReceipt,
  faArrowRightArrowLeft,
  faCircleDashed
);

export const CUSTOM_ICONS = {
  'solid-laptop-mobile-slash': findIconDefinition({
    prefix: 'fak',
    iconName: 'solid-laptop-mobile-slash',
  }),
  'solid-mobile-slash': findIconDefinition({ prefix: 'fak', iconName: 'solid-mobile-slash' }),
  'solid-tv-slash': findIconDefinition({ prefix: 'fak', iconName: 'solid-tv-slash' }),
  'solid-plug-slash': findIconDefinition({ prefix: 'fak', iconName: 'solid-plug-slash' }),
  'solid-sign-posts-slash': findIconDefinition({
    prefix: 'fak',
    iconName: 'solid-sign-posts-slash',
  }),
  'solid-calendar-days-slash': findIconDefinition({
    prefix: 'fak',
    iconName: 'solid-calendar-days-slash',
  }),
  'sharp-solid-newspaper-slash': findIconDefinition({
    prefix: 'fak',
    iconName: 'sharp-solid-newspaper-slash',
  }),
  'solid-server-slash': findIconDefinition({ prefix: 'fak', iconName: 'solid-server-slash' }),
  'solid-box-open-pen': findIconDefinition({ prefix: 'fak', iconName: 'solid-box-open-pen' }),
  'solid-ticket-pen': findIconDefinition({ prefix: 'fak', iconName: 'solid-ticket-pen' }),
  'solid-puzzle-piece-pen': findIconDefinition({
    prefix: 'fak',
    iconName: 'solid-puzzle-piece-pen',
  }),
};
